import { ToggleButton } from './ToggleButton';

type Props = {
  options: { label: string; value: string }[];
  onChange?: (value: string) => void;
  className?: string;
  selected?: string;
};

export function ToggleButtonGroup({ options, onChange, selected }: Props): JSX.Element {
  return (
    <span className="isolate inline-flex">
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          selected={option.value === selected}
          onClick={() => onChange?.(option.value)}
        >
          {option.label}
        </ToggleButton>
      ))}
    </span>
  );
}
